import { useState, useEffect, useMemo } from "react";
import { useRequest, RequestParams } from "./use-request";

export interface SocialProofType {
  userName: string;
  quantity: number;
  code: string;
  orderSubmittedTimestamp: string;
  slug: string;
  name: string;
}

const useSocialProof = (skus: string[]) => {
  const [socialProof, setSocialProof] = useState<SocialProofType | null>(null);

  const requestParams: RequestParams = useMemo(
    () => ({
      url: "/api/get-social-proofs",
      queryStringParams: { skus: JSON.stringify(skus) },
    }),
    [skus]
  );

  const { data, isLoading, error } = useRequest(requestParams);

  useEffect(() => {
    if (data) {
      setSocialProof(data.data);
    }
  }, [data]);

  return { socialProof, loading: isLoading, error };
};

export default useSocialProof;
